var LobbyInvite = function()
{
};

LobbyInvite.prototype.trigger = function() {
    return this.getjQueryObject().trigger.apply(this.getjQueryObject(), arguments);
};

LobbyInvite.prototype.getjQueryObject = function() {
    if (!this.jQueryObject) {
        this.jQueryObject = jQuery(this);
    }

    return this.jQueryObject;
};

LobbyInvite.prototype.getUrl = function (urlString) {
    return this.urls.prefix+this.urls[urlString];
};

LobbyInvite.prototype.acceptInvite = function(lobbyID, friendID) {
    jQuery.ajax({
        url: this.getUrl('acceptInvite'),
        method: "POST",
        data: {
            idlobby_room: lobbyID,
            idfriend: friendID
        },
        context: this
    }).done(function(data) {
        if (data.success) {
            this.trigger('acceptInviteDone', data);
        } else {
            this.trigger('acceptInviteFail', data);
        }
    }).fail(function(data) {
        this.trigger('acceptInviteFail', data);
    }).always(function() {
        this.trigger('acceptInviteAlways');
    });
};

LobbyInvite.prototype.refuseInvite = function (lobbyID, friendID)
{
    jQuery.ajax({
        url: this.getUrl('refuseInvite'),
        method: "POST",
        data: {
            idlobby_room: lobbyID,
            idfriend: friendID
        },
        context: this
    }).done(function(data) {
        if (data.success) {
            data.idplayer = friendID;
            data.idlobby_room = lobbyID;
            this.trigger('refuseInviteDone', data);
        } else {
            this.trigger('refuseInviteFail', data);
        }
    }).fail(function(data) {
        this.trigger('refuseInviteFail', data);
    }).always(function() {
        this.trigger('refuseInviteAlways');
    });
};

LobbyInvite.prototype.refuseAllInvites = function (lobbyID, friendID)
{
    jQuery.ajax({
        url: this.getUrl('refuseAllInvites'),
        method: "GET",
        context: this
    }).done(function(data) {
        if (data.success) {
            this.trigger('refuseAllInvitesDone', data);
        } else {
            this.trigger('refuseAllInvitesFail', data);
        }
    }).fail(function(data) {
        this.trigger('refuseAllInvitesFail', data);
    }).always(function() {
        this.trigger('refuseAllInvitesAlways');
    });
};

LobbyInvite.prototype.getAllInvites = function ()
{
    jQuery.ajax({
        url: this.getUrl('getAllInvites'),
        method: "GET",
        context: this
    }).done(function(data) {
        if (data.success) {
            this.trigger('getAllInvitesDone', data);
        } else {
            this.trigger('getAllInvitesFail', data);
        }
    }).fail(function(data) {
        this.trigger('getAllInvitesFail', data);
    }).always(function() {
        this.trigger('getAllInvitesAlways');
    });
};


LobbyInvite.prototype.urls = {
    prefix: '',
    getAllInvites: '/lobbyBeta/getLobbyInvites',
    acceptInvite: '/lobbyBeta/acceptInviteOfLobby',
    refuseInvite: '/lobbyBeta/refuseInviteOfLobby',
    refuseAllInvites: '/lobbyBeta/refuseInvitesOfAllLobby'
};